type Serializable = object | object[]

export default function toPojo<T>(value: Serializable): T {
  return JSON.parse(JSON.stringify(value))
}
